import { Play } from "lucide-react";
import { useMusicPlayer } from "@/context/MusicPlayerContext";
import { fmtTime } from "@/lib/youtube";

/**
 * Compact multi-column track list. Four columns fill a desktop row without the
 * long single list a music app usually pushes you into scrolling.
 */
export default function PopularTracks({ tracks }) {
  const { playQueue, isCurrent, isPlaying } = useMusicPlayer();
  if (!tracks || tracks.length === 0) return null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-x-6 gap-y-1">
      {tracks.map((track, i) => {
        const active = isCurrent && isCurrent(track);
        return (
          <button
            key={track.id}
            data-testid={`popular-track-${track.id}`}
            onClick={() => playQueue(tracks, i)}
            className="group flex items-center gap-3 p-2 rounded-lg hover:bg-white/5 transition-colors text-left min-w-0"
          >
            <span className="relative w-10 h-10 shrink-0">
              {track.thumbnail ? (
                <img src={track.thumbnail} alt="" className="w-10 h-10 rounded object-cover" />
              ) : (
                <span className="block w-10 h-10 rounded bg-white/10" />
              )}
              <span className="absolute inset-0 rounded bg-black/55 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <Play className="w-4 h-4 text-white" fill="white" />
              </span>
            </span>
            <span className="flex-1 min-w-0">
              <span
                className={`block text-sm font-medium truncate ${active ? "text-[#FF2A4D]" : ""}`}
              >
                {track.title}
              </span>
              <span className="block text-xs text-zinc-400 truncate">{track.artist}</span>
            </span>
            <span className="text-xs text-zinc-600 tabular-nums shrink-0 hidden sm:block">
              {active && isPlaying ? "▶" : fmtTime(track.duration)}
            </span>
          </button>
        );
      })}
    </div>
  );
}
